<template>
  <div class="input-list">
    <div
      v-if="!isClue"
      class="input-list-con"
    >
      <a-form-item
        v-for="(item, index) in list"
        :key="item._id"
        :label="item.fieldname"
        class="input-box clearfix"
        :class="{
          'en-input-box': isEnglish,
          'next-box': index,
          'isrepeatsave': item.isrepeat && item.isrepeatsave
        }"
      >
        <span
          v-decorator="[`${item.fieldkey}-${index}`, {
            validateTrigger: ['blur'],
            rules: [{
              required: item.isneeded === 1,
              message: placeholder
            }, {
              validator: validateRepeat
            }, {
              validator: checkEmail
            }, {
              validator: checkPhone
            }],
            initialValue: item.fieldvalue
          }]"
          class="input"
        >
          <a-input
            v-model="item.fieldvalue"
            :placeholder="placeholder"
            :disabled="item.disabled"
            @change="handleChange($event, item, index)"
            @blur="handleBlur(index)"
          />
        </span>
        <template v-if="list.length > 1">
          <a-input
            v-model="item.fieldMark"
            :placeholder="$t('message[782]')"
            :disabled="item.disabled"
            class="field-mark-input"
            @change="handleChange($event, item, index, 'mark')"
          />
        </template>

        <i
          v-if="index"
          class="iconfont iconicon-test8 del-icon"
          @click="handleDelete(index)"
        />
        <a
          v-if="item.isrepeat && item.is_show_view"
          href="javascript:;"
          class="look-repeat-btn"
          @click="handleClickRepeat(index)"
        >{{ $t('message["85"]') }}</a>
      </a-form-item>
      <a
        class="fs-blue add-btn"
        @click="handleAdd"
      >
        {{ $t('message["1561"]') }}
      </a>
    </div>
    <template v-else>
      <a-form-item
        v-for="(item, index) in list"
        :key="item._id"
        :label="item.fieldname"
        class="input-box clearfix"
        :class="{
          'en-input-box': isEnglish,
          'next-box': index,
          'isrepeatsave': item.isrepeat && item.isrepeatsave
        }"
      >
        <span
          v-decorator="[`${item.fieldkey}-${index}`, {
            validateTrigger: ['blur'],
            rules: [{
              required: item.isneeded === 1,
              message: placeholder
            }, {
              validator: validateRepeat
            }, {
              validator: checkEmail
            }, {
              validator: checkPhone
            }],
            initialValue: item.fieldvalue
          }]"
          class="input"
        >
          <a-input
            v-model="item.fieldvalue"
            :placeholder="placeholder"
            :disabled="item.disabled"
            @change="handleChange($event, item, index)"
            @blur="handleBlur(index)"
          />
        </span>
        <i
          v-if="index"
          class="iconfont iconicon-test8 del-icon"
          @click="handleDelete(index)"
        />
        <a
          v-if="item.isrepeat && item.is_show_view"
          href="javascript:;"
          class="look-repeat-btn"
          @click="handleClickRepeat(index)"
        >{{ $t('message["85"]') }}</a>
      </a-form-item>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { checkRepeat } from '@/services/inqueryServices'
import { getLang } from '@/lib/storage'
import { checkClueFieldRepeat } from '@/services/clue'
export default {
  name: 'InputList',

  inject: {
    myForm: {
      default: () => { }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    },
    parentKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: '',
      mark: '',
      list: [],
      currentIndex: null,
      source: []
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['repeatSaveItems']),
    inquiryId () {
      return this.$route.params.inquiryId || this.$route.params.id
    },
    pid () {
      return this.$route.params.pid
    },
    repeatTip () {
      // 存在重复信息
      return this.$t('message["134"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    isClue () {
      return this.$route.name === 'ClueCreate' || this.$route.name === 'ClueDetail'
    }

  },

  created () {
    this.value = this.data.fieldvalue
    this.setList()
  },

  destroyed () {
    this.UPDATE_REPEAT_SAVE_ITEMS({})
  },

  methods: {
    ...mapMutations('inquery/detailData', ['UPDATE_REPEAT_SAVE_ITEMS']),
    getLang,

    handleChange (e, item, index, type) {
      const { fieldtype = '', fieldkey } = this.data || {}
      let val = e.target.value
      let isMark = type === 'mark'
      if (isMark) {
        this.mark = this.list.map(item => item.fieldMark)
      } else {
        if (fieldtype === 'email') {
          val = this.filterOutChinese(val).toLowerCase()
        }

        if (val === '') {
          this.list[index].isrepeat = 0
          this.list[index].is_show_view = 0
          this.list[index].isrepeatsave = 0
          this.repeatSaveItems[fieldkey] = 0
          this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, this.repeatSaveItems))
        }

        item.fieldvalue = val.replace(/\s*/g, '')
      }
      this.value = this.list.map(item => {
        let str = (item.fieldMark && item.fieldvalue) ? '#' + item.fieldMark : ''
        return item.fieldvalue + str
      })
      this.data.fieldvalue = this.value
      // console.log(this.data.fieldvalue)
      this.$emit('change', this.value)

      this.$forceUpdate()
    },

    handleBlur (index, type) {
      let { fieldkey = '' } = this.data || {}
      this.currentIndex = index
      for (let i = 0; i < this.list.length; i++) {
        this.myForm && this.myForm.setFieldsValue({
          [`${fieldkey}-${i}`]: this.value[i] || ''
        })
      }
      this.myForm && this.myForm.validateFields()
    },

    setList () {
      let { value = [], data = {} } = this
      if (!value.length) {
        value = ['']
      }
      this.list = value.map(item => {
        let obj = { ...data }
        let isHasMark = item.indexOf('#') > -1
        // console.log(item.substring(item.match(/#{1}/).index))
        let arr = isHasMark ? item.split('#') : []
        arr = arr.filter(item => item !== '')
        obj.fieldvalue = (isHasMark ? arr[0] : item) || ''
        obj.fieldMark = isHasMark ? item.substring(item.match(/#{1}/).index + 1) : ''
        obj.isEmailError = false // 邮箱格式不正确
        obj.isPhoneError = false
        obj.isrepeat = 0
        obj.is_show_view = 0
        obj.isrepeatsave = 0
        return obj
      })
    },

    handleAdd () {
      let obj = { ...this.data }
      obj._id = Math.random() * Math.pow(10, 18)
      obj.fieldvalue = ''
      obj.isEmailError = false
      obj.isPhoneError = false
      obj.isrepeat = 0
      obj.is_show_view = 0
      obj.isrepeatsave = 0
      obj._id = Math.random() * Math.pow(10, 18)
      this.list.push(obj)
      this.value = this.list.map(item => item.fieldvalue)
      this.data.fieldvalue = this.value
      this.$emit('change', this.value)

      this.handleBlur()
    },

    handleDelete (index) {
      this.list.splice(index, 1)
      // this.value = this.list.map(item => item.fieldvalue)
      this.value = this.list.map(item => {
        let str = (item.fieldMark && item.fieldvalue) ? '#' + item.fieldMark : ''
        return item.fieldvalue + str
      })
      this.data.fieldvalue = this.value
      this.$emit('change', this.value)

      this.handleBlur()
    },

    async validateRepeat (rule, value, callback) {
      const { fieldkey = '', fieldrepeat = 0 } = this.data || {}
      let currentIndex = this.value.findIndex(item => item === value)
      let arr = value.indexOf('#') > -1 ? value.split('#') : []
      arr = arr.filter(item => item !== '')
      let newValue = value.indexOf('#') > -1 ? arr[0] : value

      if (!newValue || !fieldrepeat || currentIndex === -1) {
        callback()
        return
      }

      // let res = await checkRepeat().params({
      //   inquiryid: this.inquiryId,
      //   fieldkey,
      //   fieldvalue: value
      // }).fetch()
      let res = null
      if (this.isClue) {
        res = await checkClueFieldRepeat().params({
          clue_id: this.inquiryId,
          fieldkey: this.parentKey + '.' + fieldkey,
          fieldvalue: value
        }).fetch()
      } else {
        res = await checkRepeat().params({
          inquiryid: this.inquiryId,
          fieldkey,
          fieldvalue: newValue
        }).fetch()
      }

      const { payload = {} } = res && res.data
      const { isrepeat = 0, is_show_view: isShowView = 0, isrepeatsave = 0, source = '' } = payload

      const { isEmailError, isPhoneError } = this.list[currentIndex]
      this.list[currentIndex].isrepeat = !isEmailError && !isPhoneError && isrepeat
      this.list[currentIndex].is_show_view = isShowView
      this.list[currentIndex].source = source
      this.list[currentIndex].isrepeatsave = isrepeat && isrepeatsave
      this.$forceUpdate()

      const isError = (isEmailError || isPhoneError) ? 0 : 1
      let repeatSaveItems = {
        ...this.repeatSaveItems,
        [`${fieldkey}-${currentIndex}`]: isrepeat && isrepeatsave && isError
      }
      this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, repeatSaveItems))

      if (!isEmailError && !isPhoneError && value && isrepeat) {
        // rule.message = '存在重复信息'
        rule.message = this.$t('message["134"]')
        callback(rule.message)
      } else {
        callback()
      }
    },

    checkEmail (rule, value, callback) {
      const { fieldtype, fieldkey } = this.data
      let currentIndex = this.value.findIndex(item => item === value)
      let curValue = this.list[currentIndex]
      // let arr = value.indexOf('#') > -1 ? value.split('#') : []
      // arrNew = arr.filter(item => item !== '')
      let newValue = value.indexOf('#') > -1 ? curValue.fieldvalue : value

      if (fieldtype !== 'email' || newValue === '' || newValue === undefined) {
        callback()
        return
      }
      if (currentIndex === -1) {
        callback()
        return
      }

      if (!/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,64}$/.test(newValue)) {
        // rule.message = '邮箱不是有效的邮箱格式'
        rule.message = this.$t('message["1508"]')
        this.list[currentIndex].isEmailError = true
        let repeatSaveItems = {
          ...this.repeatSaveItems,
          [`${fieldkey}-${currentIndex}`]: 0
        }
        this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, repeatSaveItems))
        callback(rule.message)
      } else {
        rule.message = ''
        this.list[currentIndex].isEmailError = false
        callback()
      }
    },

    checkPhone (rule, value, callback) {
      const { fieldtype, fieldkey, fieldconfig = {} } = this.data
      let currentIndex = this.value.findIndex(item => item === value)
      // let newValue = value.indexOf('#') > -1 ? value.split('#')[0] : value
      let arr = value.indexOf('#') > -1 ? value.split('#') : []
      arr = arr.filter(item => item !== '')
      let newValue = value.indexOf('#') > -1 ? arr[0] : value
      if (fieldtype !== 'phone' || newValue === '' || newValue === undefined) {
        callback()
        return
      }
      if (!fieldconfig.check) {
        callback()
        return
      }
      if (currentIndex === -1) {
        callback()
        return
      }

      if (!/^[1][0,3,4,5,6,7,8,9][0-9]{9}$/.test(newValue)) {
        // rule.message = '手机格式不正确'
        rule.message = this.$t('message["1111"]')
        this.list[currentIndex].isPhoneError = true
        let repeatSaveItems = {
          ...this.repeatSaveItems,
          [`${fieldkey}-${currentIndex}`]: 0
        }
        this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, repeatSaveItems))
        callback(rule.message)
      } else {
        rule.message = ''
        this.list[currentIndex].isPhoneError = false
        callback()
      }
    },

    filterOutChinese (str) {
      var temp = ''
      for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) > 0 && str.charCodeAt(i) < 255) || str[i] === '，') {
          temp += str.charAt(i)
        }
      }
      return temp
    },

    handleClickRepeat (index) {
      const { fieldkey } = this.data
      const fieldvalue = this.value[index]
      let href = ''
      let arr = fieldvalue.indexOf('#') > -1 ? fieldvalue.split('#') : []
      arr = arr.filter(item => item !== '')
      let newValue = fieldvalue.indexOf('#') > -1 ? arr[0] : fieldvalue
      // let newValue = fieldvalue.indexOf('#') > -1 ? fieldvalue.split('#')[0] : fieldvalue
      if (this.list[index].source === 'clue') {
        const { parentKey } = this
        href = `${location.origin}/project/${this.pid}/inquery/clue?search_type=${parentKey}.${fieldkey}&kwd=${newValue}`
      } else {
        href = `${location.origin}/project/${this.pid}/inquery/repeat?repeatfieldkey=${fieldkey}&repeatfieldvalue=${newValue}`
      }

      let tempwindow = window.open()
      tempwindow.location = href
    }
  }
}
</script>

<style lang="scss" scoped>
.next-box ::v-deep {
  .ant-form-item-label {
    display: none;
  }
}
.input-box ::v-deep {
  .wrap {
    position: relative;
  }
  .del-icon {
    margin-left: 5px;
    color: #ccc;
  }
  .look-repeat-btn {
    position: absolute;
    left: 90px;
    top: 30px;
    font-size: 13px;
    line-height: 1;
  }
  .ant-form-explain {
    margin-top: 3px;
    font-size: 13px;
  }
}
.en-input-box::v-deep {
  .look-repeat-btn {
    left: 200px !important;
  }
}
.isrepeatsave ::v-deep {
  .has-error .ant-form-explain {
    color: #f6a953;
  }
}
.add-btn {
  display: block;
  width: 60px;
  margin: 0 0 24px 140px;
}
.input-list-con::v-deep{
  .ant-input{
    &:first-child{
      margin-right: 10px;
    }
    &.field-mark-input{
      border-color: #d6d6d6;
    }
    width: 240px;
  }
}

</style>
